import React from "react";

// COMPONENTS
import { Icon, Image } from "semantic-ui-react";
import { useSelector } from "react-redux";
import NewTabLink from "./newTabLink";

// CONSTANTS
import { PUBLIC_SITE_URL } from "../../env";

// OTHER
import { ReactComponent as LogoTelethon7 } from "../../semantic/assets/images/logo-telethon7.svg";
import { ReactComponent as LogoGrassrootz } from "../../semantic/assets/images/logo-grassrootz.svg";
import { RootState } from "../../redux/store";
import { getImageUrl } from "../../helpers/imageHelper";

// prettier-ignore
// @ts-ignore
const CustomIcon = ({ name }: { name: string }) => (<Icon name={name} size="large" />);

const defaultSocial = {
  youtube: "https://www.youtube.com/user/Telethon1968",
  facebook: "https://www.facebook.com/telethon7",
  twitter: "https://twitter.com/telethon7",
  instagram: "https://www.instagram.com/telethon7",
};

const defaultLogo = {
  href: "https://www.telethon7.com",
  image: <LogoTelethon7 />,
};

const Footer = () => {
  const page = useSelector((state: RootState) => state.page);
  let socialLinks = undefined;
  let logo = defaultLogo;
  // prettier-ignore
  const social = page?.campaign?.template?.value?.customSetup?.standaloneDonationForm?.social;
  // prettier-ignore
  const description = page?.campaign?.template?.value?.customText?.standaloneDonationForm?.footer;
  const heroImagePath = page?.campaign?.template?.value?.heroImagePath;

  // explicitly check value as it's a nullish type
  if (social?.enabled === true) {
    socialLinks = social;
  } else if (social?.enabled !== false) {
    socialLinks = defaultSocial;
  }

  if (heroImagePath) {
    logo = { image: <Image src={getImageUrl(heroImagePath)} />, href: "" };
  }

  return (
    <div className="powered-by-large">
      <div className="powered-by-large-inner">
        {socialLinks && (
          <div className="social-list">
            {socialLinks.youtube && (
              <NewTabLink href={socialLinks.youtube}>
                <CustomIcon name="youtube play" />
              </NewTabLink>
            )}
            {socialLinks.facebook && (
              <NewTabLink href={socialLinks.facebook}>
                <CustomIcon name="facebook f" />
              </NewTabLink>
            )}
            {socialLinks.twitter && (
              <NewTabLink href={socialLinks.twitter}>
                <CustomIcon name="twitter" />
              </NewTabLink>
            )}
            {socialLinks.instagram && (
              <NewTabLink href={socialLinks.instagram}>
                <CustomIcon name="instagram" />
              </NewTabLink>
            )}
          </div>
        )}
        {logo && (
          <div className="footer-logo">
            <NewTabLink href={logo.href}>{logo.image}</NewTabLink>
          </div>
        )}
        <p className="footer-copyright">
          {description ||
            `© ${new Date().getFullYear()} Channel 7 Telethon Trust`}
        </p>
        <NewTabLink className="footer-link" href={PUBLIC_SITE_URL}>
          <span>Powered by</span>
          <LogoGrassrootz />
        </NewTabLink>
      </div>
    </div>
  );
};

export default Footer;
